<script setup lang="ts">
import AppDesktopNav, { type NavSection } from '@/components/common/AppDesktopNav.vue'

defineOptions({ name: 'PageLayout' })

/** Marketplace pages pass their section: from `md` up they swap the mobile
 *  `#navbar` for the desktop top nav (the mobile AppTabbar hides itself). */
defineProps<{ nav?: NavSection }>()

/** Scroll events from the page body, the only scrolling element. */
defineEmits<{ scroll: [event: Event] }>()
</script>

<template>
  <!-- A route page: header and footer stay put, only the body scrolls. -->
  <div class="app-page" :class="{ 'app-page-with-banner': $slots.banner }">
    <!-- A full-width announcement above everything, like the homepage bounty banner. -->
    <slot name="banner" />
    <AppDesktopNav v-if="nav" :active="nav" />
    <div class="page-navbar" :class="{ 'md:hidden': nav }">
      <slot name="navbar" />
    </div>
    <div class="app-page-content" @scroll="$emit('scroll', $event)">
      <slot />
    </div>
    <slot name="fixed" />
  </div>
</template>

<style scoped>
.app-page {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--app-page-bg);
}
.page-navbar {
  flex: none;
}
/* The banner already covers the notch inset; the header would pad it twice. */
.app-page-with-banner .page-navbar :deep(.page-header) {
  padding-top: 0;
}
.app-page-content {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}
</style>
